// 📁 hooks/useMarqueeTimeWindow.ts
import { useEffect, useState } from "react";

export function useMarqueeTimeWindow(startTime: Date, endTime: Date) {
    const [showMarquee, setShowMarquee] = useState(false);

    useEffect(() => {
        const checkTime = () => {
            const currentTime = new Date();
            setShowMarquee(currentTime >= startTime && currentTime <= endTime);
        };

        checkTime();
        const intervalId = setInterval(checkTime, 1000);
        return () => clearInterval(intervalId);
    }, [startTime, endTime]);

    return showMarquee;
}
